/* STENCIL IMPORTS */
import { Host, h } from "@stencil/core";
const ARROW_DOWN = "ArrowDown";
const ARROW_UP = "ArrowUp";
export class ChSuggestListItem {
    constructor() {
        this.iconSrc = undefined;
        this.value = undefined;
    }
    // 2.REFERENCE TO ELEMENTS //
    el;
    // 3.STATE() VARIABLES //
    // 4.PUBLIC PROPERTY API / WATCH'S //
    // 5.EVENTS (EMIT) //
    /**
     * This event is emitted every time the item is selected, either by clicking on it, or by pressing Enter.
     */
    itemSelected;
    /**
     * This event is emitted every time the item is about to lose focus, by pressing the "ArrowUp" or "ArrowDown" keyboard keys.
     */
    focusChangeAttempt;
    // 6.COMPONENT LIFECYCLE EVENTS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    getItemIndexes = () => {
        const parentElement = this.el.parentElement;
        if (parentElement.nodeName === "CH-SUGGEST") {
            const chSuggest = parentElement;
            let itemIndex = -1;
            const suggestListItemsArray = Array.from(chSuggest.querySelectorAll(":scope > ch-suggest-list-item"));
            for (let index = 0; index < suggestListItemsArray.length; index++) {
                // Then get the item index
                if (suggestListItemsArray[index] === this.el) {
                    itemIndex = index;
                    break;
                }
            }
            return {
                itemIndex: itemIndex,
                listIndex: undefined // the items does not belongs to a list
            };
        }
        else if (parentElement.nodeName === "CH-SUGGEST-LIST") {
            const chSuggestList = parentElement;
            const chSuggestListsArray = Array.from(chSuggestList.parentElement.querySelectorAll(":scope > ch-suggest-list"));
            const listIndex = chSuggestListsArray.findIndex(list => {
                return list === chSuggestList;
            });
            if (listIndex !== -1) {
                const listItemsArray = Array.from(chSuggestList.querySelectorAll("ch-suggest-list-item"));
                const itemIndex = listItemsArray.findIndex(item => {
                    return item === this.el;
                });
                return {
                    itemIndex: itemIndex,
                    listIndex: listIndex
                };
            }
        }
    };
    handleClick = () => {
        const indexes = this.getItemIndexes();
        this.itemSelected.emit({
            value: this.value || this.el.innerText,
            description: this.el.innerText,
            icon: this.iconSrc,
            indexes: indexes
        });
    };
    handleKeyDown = (e) => {
        if (e.code === ARROW_UP || e.code === ARROW_DOWN) {
            e.preventDefault();
            this.focusChangeAttempt.emit({
                el: this.el,
                code: e.code
            });
        }
    };
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, { role: "listitem", onKeyDown: this.handleKeyDown }, h("button", { part: "button", onClick: this.handleClick }, h("slot", { name: "icon" }), h("div", { class: "content-wrapper", part: "content-wrapper" }, h("slot", null)))));
    }
    static get is() { return "ch-suggest-list-item"; }
    static get encapsulation() { return "shadow"; }
    static get delegatesFocus() { return true; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-suggest-list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-suggest-list-item.css"]
        };
    }
    static get properties() {
        return {
            "iconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The icon url"
                },
                "attribute": "icon-src",
                "reflect": false
            },
            "value": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The item value"
                },
                "attribute": "value",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "itemSelected",
                "name": "itemSelected",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is emitted every time the item is selected, either by clicking on it, or by pressing Enter."
                },
                "complexType": {
                    "original": "SuggestItemSelectedEvent",
                    "resolved": "{ value: any; indexes: SuggestItemIndexes; description?: string; icon?: string; }",
                    "references": {
                        "SuggestItemSelectedEvent": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/suggest/suggest-list-item/ch-suggest-list-item.tsx",
                            "id": "src/components/suggest/suggest-list-item/ch-suggest-list-item.tsx::SuggestItemSelectedEvent"
                        }
                    }
                }
            }, {
                "method": "focusChangeAttempt",
                "name": "focusChangeAttempt",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "This event is emitted every time the item is about to lose focus, by pressing the \"ArrowUp\" or \"ArrowDown\" keyboard keys."
                },
                "complexType": {
                    "original": "FocusChangeAttempt",
                    "resolved": "{ el: HTMLChSuggestListItemElement; code: ChSuggestKeyDownEvents; }",
                    "references": {
                        "FocusChangeAttempt": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/suggest/suggest-list-item/ch-suggest-list-item.tsx",
                            "id": "src/components/suggest/suggest-list-item/ch-suggest-list-item.tsx::FocusChangeAttempt"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-suggest-list-item.js.map
